const SCRIPT_ID = 'google-identity-services';

export function loadGoogleIdentityServices(): Promise<void> {
  if (window.google?.accounts?.id) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const current = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if (current) {
      current.addEventListener('load', () => resolve(), { once: true });
      current.addEventListener('error', () => reject(new Error('Google přihlášení se nepodařilo načíst.')), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Google přihlášení se nepodařilo načíst.'));
    document.head.appendChild(script);
  });
}

declare global {
  interface Window {
    google?: { accounts?: { id?: {
      initialize(config: { client_id: string; callback: (response: { credential?: string }) => void; auto_select?: boolean; hd?: string }): void;
      renderButton(element: HTMLElement, options: { theme?: string; size?: string; text?: string; shape?: string; width?: number }): void;
      disableAutoSelect(): void;
    } } };
  }
}
